import { Navigate, useParams } from 'react-router-dom';

// import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useLoaders } from '@/shared';
import { useGetContrato } from '@/shared/actions/erp';
import { ContentUpdateClienteData } from './requests';

export type ClienteUpdateDataPageProps = {};

const ClienteUpdateDataPage: React.FC<
  ClienteUpdateDataPageProps
> = () => {
  // useCheckPermissions(PermissionsEnum.api_change_agendamiento);
  const returnUrlClientesContratosPage =
    ROUTER_PATHS.clientes.clienteContratoNav;
  const { id } = useParams();

  const { data, isLoading, isRefetching, } = useGetContrato(id!);
  useLoaders(isLoading || isRefetching);

  if (isLoading) return null;
  if (!data?.data?.id_contrato)
    return <Navigate to={returnUrlClientesContratosPage} />;


  return (
    <ContentUpdateClienteData
      title="Pendiente Actualizar"
      contract={data?.data}
    />
  );
};

export default ClienteUpdateDataPage;
